import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent,
    useDisclosure,
    Text,
    DrawerCloseButton,
    Skeleton
} from '@salesforce/retail-react-app/app/components/shared/ui'

const ExclusiveRewardsBlock = React.forwardRef(({ loyaltyData, isLoyaltyDataLoading }, ref) => {
    const rewards = loyaltyData?.rewards
    const rewardsDataMapping = loyaltyData?.rewardsDataMapping

    // Refs and state for popup handling
    const containerRef = useRef(null)
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [popupContent, setPopupContent] = useState('')

    const handlePopupClick = (event) => {
        event.preventDefault()
        const trigger = event.target.closest('[data-popup-trigger]')

        if (!trigger) return

        const tileWrapper = trigger.closest('[data-tile-index]')

        if (!tileWrapper) return

        const tileIndex = parseInt(tileWrapper.getAttribute('data-tile-index'))
        const reward = rewards?.[tileIndex]

        if (reward) {
            const drawerContent = rewardsDataMapping[reward['popup-content-id']]
            if (drawerContent) {
                setPopupContent(drawerContent)
                onOpen()
            }
        }
    }

    // Event delegation for popup triggers
    useEffect(() => {
        const container = containerRef.current
        if (container) {
            container.addEventListener('click', handlePopupClick)
            return () => {
                container.removeEventListener('click', handlePopupClick)
            }
        }
    }, [rewards, rewardsDataMapping, onOpen])

    return (
        <Box ref={ref}>
            <Box ref={containerRef}>
                <Skeleton isLoaded={!isLoyaltyDataLoading}>
                    {rewards?.map((reward, index) => {
                        const content = rewardsDataMapping && rewardsDataMapping[reward['tile-content-id']]
                        return (content &&
                            <Box
                                key={index}
                                data-tile-index={index}
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                        )
                    })}
                </Skeleton>
            </Box>

            <Drawer
                placement="right"
                isOpen={isOpen}
                onClose={onClose}
                onOpen={onOpen}
                size="md"
                scrollBehavior="inside"
                isFullHeight={true}
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerBody>
                        <Box dangerouslySetInnerHTML={{ __html: popupContent }} />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Box>
    )
})

ExclusiveRewardsBlock.propTypes = {
    loyaltyData: PropTypes.object,
    isLoyaltyDataLoading: PropTypes.bool
}

export default ExclusiveRewardsBlock
